import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

const types = [
	{ title: 'Full Service Planning' },
	{ title: 'Partial Planning' },
	{ title: 'Month of Coordination' },
	{ title: 'Day of Coordination' },
	{ title: 'Other' },
]

function PlanningSupport({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>What kind of support are you looking for?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{types.map((type, idx) => (
									<ButtonCustom
										key={idx}
										data-cy={`${type.title}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.plannerSupport === type.title
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.plannerSupport === type.title
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({...weddingData, plannerSupport: type.title})
										}
									>
										{type.title}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					onClick={() => {
						if(!weddingData?.plannerSupport){
                            return toastHelper('Please select a type of support', 'error')
                        }
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.3} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default PlanningSupport
